<template>
  <div>

    <div class="main-content main-customer font1rem minheight100">
      <!-- one tab -->
      <div class="conatiner-fluid d1" id="DataA">
        <div class="row">
          <div class="col-sm-8 offset-2 pl-1 pr-1 py-2">

            <table class="w-100 table ">
              <thead>
                <tr>
                  <th></th>
                  <th>Lizenz</th>
                  <th class="text-center">Aktivierungsdatum</th>
                  <th class="text-center">Anzahl Gastzugänge</th>
                  <th class="text-center">Anzahl aktive Benutzer</th>
                  <th class="text-center">Anzahl aktive Projekte</th>
                  <th class="text-center">Anzahl archivierte Projekte</th>
                  <th class="text-center">Anzahl Fotos</th>
                  <th class="text-center">Anzahl Pläne</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in licences" :class="{ 'disabled' : index > 0 }">
                  <td>
                    <i class="fa fa-circle" style="color:green" v-if="index == 0"></i>
                    <i class="fa fa-circle" style="color:red" v-else></i>
                  </td>
                  <td>
                    {{licencestring(item.licence_typ)}}
                  </td>
                  <td class="text-center">{{ item.activationdate | toDEDate('DD.MM.YYYY') }}</td>
                  <td class="text-center">{{ customerdata.userguestcount }} / &#8734;</td>
                  <td class="text-center" :class="{ 'overuse': (customerdata.usercount > item.usercount && index == 0) }">{{ customerdata.usercount }} / {{ item.usercount }}</td>
                  <td class="text-center" :class="{ 'overuse': (customerdata.projectcount > item.projectcount && index == 0) }">{{customerdata.projectcount}} / {{ item.projectcount }}</td>
                  <td class="text-center">{{ customerdata.projectarchivcount }} / &#8734;</td>
                  <td class="text-center" :class="{ 'overuse': (customerdata.photocount > item.photocount && index == 0 && item.photocount != 0) }">
                    <span style="font-size:14px" v-if="item.photocount == '0'">&#8734;</span>
                    <span v-else>{{customerdata.photocount}} / {{item.photocount}}</span>
                  </td>
                  <td class="text-center":class="{ 'overuse': (customerdata.plancount > item.plancount && index == 0 && item.plancount != 0) }">
                    <span style="font-size:14px" v-if="item.plancount == '0'">&#8734;</span>
                    <span v-else>{{customerdata.plancount}} / {{item.plancount}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

import axios from '../../../utils/axiosinstance'
// import axios from 'axios'
import moment from 'moment/moment'

export default {
  name: 'licences',
  data () {
    return {
      'area': 'licences',
      'customerid': '',
      customerdata: {},
      licences: []
    }
  },
  filters: {
    toDEDate: function(string, format = '') {
      if(format != '') {
        return moment(string).format(format)
      }
      return moment(string).format('DD.MM.YYYY HH:mm:ss')
    }
  },

  mounted () {
    this.customerid = this.$route.params.customerid
    this.fixElementHeights()
    console.log('LICENCES MOUNTED')
    this.getCustomerLicences()
    this.getcustomerdata()
  },

  methods: {

    licencestring(licencstring) {
      if(licencstring == 'project') {
        return 'Projektlizenz'
      } else {
        return 'Enterprise Lizenz'
      }
    },

    fixElementHeights () {
      let headerheight = $('header').height()
      $('#mySidenav, .main-content').css({'top': headerheight})
      // $('.main-content').css({'margin-left':'210px'})
      $('#mySidenav').css({'height':'calc(100vh - '+headerheight+'px)'});
      console.log('sidenavheight', headerheight)
    },

    async getCustomerLicences() {
      let _this = this

      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.customerid],
        serviceName: "ProjectdocuCustomer",
        methodName: "getcustomerlicences"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        _this.licences = response.data.licences
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });
    },

    async getcustomerdata() {
      let _this = this
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.$route.params.customerid],
        serviceName: "ProjectdocuCustomer",
        methodName: "getcustomerdata"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        console.log(response)
        if(response.data == false) {
          // Do Nothing because is not admin!
        } else {
          _this.customerdata = response.data
          console.log('CUSTOMER_DATA', _this.customerdata)
        }

        console.log('This', _this.isCustomerAdmin, _this.customers)
      }).catch(e => {
      });
    }


  },

  created () {
    console.log('LICENCES CREATED')
  }
}
</script>
<style>
tr.disabled td {
  color: lightgray;
}
tr.disabled:hover td {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/components/licences.vue